<template>
    <div>
        <crud-facecade
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            :tableHeight="tableHeight"
            v-wechat-title="title"
            :addButton="{ permission: 'workbar:create' }"
            :updateButton="{ enabled: false, permission: 'workbar:update' }"
            :deleteButton="{ enabled: true, permission: 'workbar:delete' }"
            @AssignMenus="AssignMenus"
            @LoadSaveAsView="LoadSaveAsView"
        >
        </crud-facecade>
        <tree-dialog title="分配菜单" :strictly="true" :visible.sync="assignMenu.dialogVisible" :data="assignMenu.data" :default-checked-keys="assignMenu.defaultCheckedKeys" @confirm="SaveMenus">
            <template slot="row" slot-scope="{ node, data }">
                <span>{{ data.name }}</span>
                <span>
                    {{ data.path }}
                </span>
            </template>
        </tree-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `WorkField`,
    props: {},
    data() {
        return {
            title: `工作栏`,
            url: `/api/AcisSystem/WorkBar`,
            buttons: [
                {
                    label: `分配菜单`,
                    type: `primary`,
                    emit: `AssignMenus`,
                    permission: `default`
                },
                {
                    class: `is-plain`,
                    label: `编辑`,
                    type: `primary`,
                    emit: `LoadingUpdateView`,
                    permission: `workbar:update` // user:assignRole
                }
            ],
            assignMenu: {
                dialogVisible: false,
                defaultCheckedKeys: [],
                data: [],
                workbarId: ``
            },
            saveAs: {
                dialogVisible: false,
                data: {}
            }
        }
    },
    created() {},
    computed: {
        ...mapGetters([`permissions`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `icons`,
                    prop: `icon`,
                    label: `图标`,
                    width: `60`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `menu_icons`
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `description`,
                    label: `描述`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `select`,
                    prop: `is_built_in_system`,
                    label: `是否系统内置`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `business_level`,
                    label: `菜单业务级别`,
                    // width: "180",
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.sys_enums.Menu || [],
                    default: 0,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                }
            ]
        }
    },
    mounted() {},
    methods: {
        loadAllMenus() {
            // 获取所有菜单 包括禁用的
            // return this.myaxios.get("/api/AcisSystem/Permission/Get");
            return this.myaxios.get(`/api/AcisSystem/Menu/Get`)
        },
        loadWorkbar(workbarId) {
            // 获取某工作栏的菜单
            return this.myaxios.get(`/api/AcisSystem/WorkBar/GetMenus/${workbarId}`)
            // return this.myaxios.post(`/api/AcisSystem/WorkBar/AssociatedMenus`,{work_bar_id:fieldid});
        },
        AssignMenus({ row, index }) {
            let that = this
            that.assignMenu.workbarId = row.id
            that.axios
                .all([this.loadAllMenus(), this.loadWorkbar(row.id)])
                .then(
                    that.axios.spread(function(allMenu, workbarMenus) {
                        // let v_menus = _.filter (allMenu, {business_level: row.business_level,is_deleted:false})
                        let vMenus = _.filter(allMenu, { is_deleted: false })

                        let allid = vMenus.map(ar => ar.id)
                        let root = _.filter(vMenus, function(r) {
                            return _.indexOf(allid, r.parent_id) == -1
                        })
                        // let root = _.filter(v_menus, { parent_id: 0 })
                        that.assignMenu.dialogVisible = true
                        let treedata = that.switchToTree(root, vMenus)
                        // 科室级
                        if (row.business_level && row.business_level == `0`) {
                            treedata = _.filter(treedata, function(r) {
                                return _.includes(r.name, `科室`)
                            })
                        }
                        // 患者级
                        if (row.business_level && row.business_level == `1`) {
                            treedata = _.filter(treedata, function(r) {
                                return _.includes(r.name, `患者`)
                            })
                        }
                        that.assignMenu.data = treedata
                        // let menuids = workbar&&workbar.MenuModels&&workbar.MenuModels.map(m => m.id)
                        that.assignMenu.defaultCheckedKeys = workbarMenus
                    })
                )
                .catch(function(error) {
                    //  网络等其他原因
                    console.log(error)
                })
        },
        switchToTree(root, menus) {
            return root.map(r => {
                let children = _.filter(menus, { parent_id: r.id })
                return {
                    id: r.id,
                    name: r.name,
                    path: r.url,
                    children: children.length > 0 ? this.switchToTree(children, menus) : []
                }
            })
        },
        SaveMenus(e) {
            let that = this
            let allMenus = []
            e.forEach(v => {
                let checkedMenus = that.findItemRecursive(that.assignMenu.data, v.id)
                checkedMenus.forEach(m => {
                    if (_.findIndex(allMenus, all => all.id == m.id) == -1) {
                        allMenus.push(m)
                    }
                })
            })
            let cMenus = allMenus.map(v => {
                return { menu_id: v.id, work_bar_id: this.assignMenu.workbarId }
            })

            that.assignMenu.dialogVisible = false
            this.myaxios.post(`/api/AcisSystem/WorkBar/AssociatedMenus`, cMenus).then(
                data => {
                    that.assignMenu.dialogVisible = false
                    console.log(data)
                },
                res => {
                    console.log(res)
                }
            )
        },
        findItemRecursive(tree, itemId, path = []) {
            for (const item of tree) {
                if (item.id === itemId) {
                // 找到目标项
                    return [...path, item]
                }
                if (item.children && item.children.length > 0) {
                    const result = this.findItemRecursive(item.children, itemId, [...path, item])
                    if (result) {
                        // 子树中找到目标项
                        return result
                    }
                }
            }
            // 未找到目标项
            return null
        },
        LoadSaveAsView() {}
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/WorkField/Index.vue